<template>
  <span class="unit">{{ mappedUnit }}</span>
</template>

<script>

const unitMap = {
  QUANTITY: 'Einheiten',
  MINUTE: 'Minuten',
  GB: 'GB',
  MB: 'MB'
}

export default {
  name: 'Unit',
  computed: {
    mappedUnit () {
      return unitMap[this.unit]
    }
  },
  props: {
    unit: {
      type: String
    }
  }
}
</script>
